import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { DiscountAtCheckout } from '../../interfaces/DiscountAtCheckout/DiscountAtCheckout';
import {
  getDiscountsAtCheckout,
  updateDiscountsAtCheckout,
} from '../../api/DiscountAtCheckout';
import { sharedStyles } from '../../utils/Style';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import { UpsertDiscountAtCheckoutDialog } from './UpsertDiscountAtCheckoutDialog';
import { Waiting } from '../../components/Waiting/Waiting';
import { DiscountAtCheckoutTable } from './DiscountAtCheckoutTable';
import { DiscountAtCheckoutTabs } from './DiscountAtCheckoutTabs';

export const DiscountAtCheckoutProductsPage = () => {
  const [discountToDelete, setDiscountToDelete] = useState<
    DiscountAtCheckout | undefined
  >(undefined);
  const [showInsertDialog, setShowInsertDialog] = useState(false);
  const [clickedDiscount, setClickedDiscount] = useState<
    DiscountAtCheckout | undefined
  >(undefined);
  const [discounts, setDiscounts] = useState<DiscountAtCheckout[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshDiscounts = () => {
    setLoading(true);
    getDiscountsAtCheckout()
      .then(setDiscounts)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshDiscounts();
  }, []);

  const handleCloseDialog = () => {
    setShowInsertDialog(false);
    setClickedDiscount(undefined);
  };

  const handleDelete = () => {
    if (!discountToDelete) {
      return;
    }

    setDiscountToDelete(undefined);
    setLoading(true);
    updateDiscountsAtCheckout(
      discounts.filter((x) => x.id !== discountToDelete.id),
    )
      .then(refreshDiscounts)
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <ConfirmDialog
        content='Gerçekten seçili kasa önü ürününü silmek istiyor musunuz'
        open={!!discountToDelete}
        onClose={() => setDiscountToDelete(undefined)}
        onConfirm={handleDelete}
        color='error'
      />

      <UpsertDiscountAtCheckoutDialog
        open={showInsertDialog || !!clickedDiscount}
        onClose={handleCloseDialog}
        onUpsert={() => {
          refreshDiscounts();
          handleCloseDialog();
        }}
        existingDiscounts={discounts}
        clickedDiscount={clickedDiscount}
      />

      <Waiting open={loading} />

      <DiscountAtCheckoutTabs selectedTab='products' />

      <Box sx={{ p: 3 }}>
        <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
          Kasa Önü Ürünleri
        </Typography>

        <Button
          variant='contained'
          startIcon={<AddIcon />}
          onClick={() => setShowInsertDialog(true)}
          sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
        >
          Yeni İndirim
        </Button>

        <DiscountAtCheckoutTable
          rows={discounts}
          onClickRow={setClickedDiscount}
          onDeleteRow={setDiscountToDelete}
        />
      </Box>
    </Box>
  );
};
